import { Controller } from 'stimulus'
import { attr } from 'utils/dom'

export default class extends Controller {
  static targets = ['label', 'checkbox']

  connect () {
    this.toggleHoverText(this.checkboxTarget.checked)
  }

  toggle () {
    const checkbox = this.checkboxTarget
    const url = attr('data-url', checkbox)

    checkbox.disabled = true

    fetch(url, { method: 'PATCH', headers: csrfHeaders() })
      .then(response => response.ok ? response.json() : Promise.reject(response))
      .then(({ state }) => {
        checkbox.disabled = false
        checkbox.checked = state
        this.toggleHoverText(state)
      })
      .catch(async (response) => {
        checkbox.disabled = false
        checkbox.checked = !checkbox.checked
        const data = await response.json().catch(() => null)
        const redirectionLocation = data?.redirection_location
        if (redirectionLocation) {
          window.location.href = redirectionLocation
        }
      })
  }

  toggleHoverText (value) {
    if (value) {
      this.labelTarget.removeAttribute('title')
    } else {
      this.labelTarget.setAttribute(
        'title',
        attr('data-title', this.labelTarget)
      )
    }
  }
}
